import { Swiper, SwiperSlide } from 'swiper/react';
import { ReactChild, useRef } from 'react';
import { SwiperProps } from 'swiper/react/swiper-react';
import 'swiper/css';
import './carousel.css';

interface CarouselProps<T> {
    title: string;
    items: T[];
    itemRenderFn: (item: T) => ReactChild;
    swiperProps?: SwiperProps;
}

export default function Carousel<T>({ title, items, itemRenderFn, swiperProps }: CarouselProps<T>) {
    const swiper: any = useRef();
    const onSwipe = (next: boolean) => {
        if (next) {
            swiper.current?.slideNext();
        } else {
            swiper.current?.slidePrev();
        }
    };
    return (
        <div>
            <div className="product-features__head">
                <h2 className="product-features__title">{title}</h2>
                <div className="swiper__nav-cont">
                    <div
                        className="swiper-button-prev product-items-btn-prev product-items-btn-prev-0"
                        role="button"
                        aria-label="Previous slide"
                        aria-controls="swiper-wrapper-bdfd7a5510c4d8a1d"
                        aria-disabled="true"
                        onClick={() => onSwipe(false)}
                    >
                        <svg
                            className="icon"
                            width="12"
                            height="18"
                            viewBox="0 0 12 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10 16.37L2 9l8-7.369"
                                stroke="#000"
                                strokeWidth="2"
                                strokeLinecap="square"
                            />
                        </svg>
                    </div>
                    <div
                        className="swiper-button-next product-items-btn-next product-items-btn-next-0"
                        role="button"
                        aria-label="Next slide"
                        aria-controls="swiper-wrapper-bdfd7a5510c4d8a1d"
                        aria-disabled="false"
                        onClick={() => onSwipe(true)}
                    >
                        <svg
                            className="icon"
                            width="12"
                            height="18"
                            viewBox="0 0 12 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10 16.37L2 9l8-7.369"
                                stroke="#000"
                                strokeWidth="2"
                                strokeLinecap="square"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <Swiper
                onSwiper={(sw) => (swiper.current = sw)}
                slidesPerView={'auto'}
                loop={false}
                {...swiperProps}
            >
                {items.map((item, idx) => (
                    <SwiperSlide key={idx}>{itemRenderFn(item)}</SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
